const state = {
  // 项目ID
  projectID: 0,
  // 二维码id
  QRCodeID: -1,
  // 二维码类型
  QRCodeType: '',
  // 海报标题文字
  posterTitle: '',
  // 海报数据项显示内容
  posterData: [{ key: '自定义字段', value: '自定义内容' }],
  // 创建二维码或者是编辑二维码状态 create创建 edit为编辑
  editorStatus: 'edit',
  // 二维码图片文件
  QRCodeFile: null,
  // 富文本框内容
  editorHtmlData: '',
  // 显示预览效果弹窗标识
  isShowEditorPreview: false,
  // 二维码图片刷新
  qrcodeImageRefresh: false,
  // 显示编辑海报标题弹窗
  isShowPosterTable: false,
  // 选中模板名称
  templateName: '模板1',
}

export default state
